import Queries from "../../queries/queries2";
import React from "react";
import RentabilityChart from "./RentabilityChart";
import ReportingContainer from "../Reporting/ReportingContainer";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

class RentabilityContainer extends ReportingContainer {
  render() {
    return (
      <ReportingContainer
        {...this.props}
        type={"RENTABILITY"}
        // header={"ids_rentability"}
        header={"ids_reports"}
        query={Queries.getRentabilityReportData}
        Chart={RentabilityChart}
        hideBudgetTypeSelect={true}
        hideReportsTypeSelect={false}
      />
    );
  }
}

export default withRouter(injectIntl(RentabilityContainer));
